<template>
  <div>
    <div class="content">
      <div class="header-table">
        <table>
          <tbody>
            <tr>
              <td class="header-in-table">{{ $t('안전·보건 순회점검 결과보고서') }}</td>
              <td rowspan="2" class="th-background" style="width: 40px">결<br /><br />재</td>
              <td class="th-background" style="width: 120px">{{ $t('작성자') }}</td>
              <td class="th-background" style="width: 120px">{{ $t('검토자') }}</td>
              <td class="th-background" style="width: 120px">{{ $t('회람자') }}</td>
              <td class="th-background" style="width: 120px">{{ $t('승인자') }}</td>
            </tr>
            <tr>
              <td class="content-title" valign="bottom">{{ $t('1. 개요') }}</td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign1 !== 'undefined' ? `url(${form.sign1.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign2 !== 'undefined' ? `url(${form.sign2.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign3 !== 'undefined' ? `url(${form.sign3.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign4 !== 'undefined' ? `url(${form.sign4.sign})` : '' }"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <table>
          <tbody>
            <tr>
              <th>{{ $t('학교(기관명)') }}</th>
              <td colspan="3">{{ form.stdInfo.field_name }}</td>
              <th>{{ $t('지원청') }}</th>
              <td>{{ form.inputA_1 }}</td>
              <th>{{ $t('설립') }}</th>
              <td>{{ form.inputA_2 }}</td>
            </tr>
            <tr>
              <th>{{ $t('점검일') }}</th>
              <td colspan="3">{{ form.inputA_3 }}</td>
              <th>{{ $t('위탁여부') }}</th>
              <td colspan="3">{{ form.inputA_5 }}</td>
            </tr>
            <tr>
              <th>{{ $t('점검자') }}</th>
              <td colspan="3">{{ form.inputA_4 }}</td>
              <th>{{ $t('위탁내용') }}</th>
              <td colspan="3">{{ form.inputA_6 }}</td>
            </tr>
<!--            <tr>-->
<!--              <th>{{ $t('점검분야') }}</th>-->
<!--              <td colspan="3">-->
<!--                <div class="grid grid-cols-4 gap-x-6 gap-y-4 p-4">-->
<!--                  <div v-for="(_title, _title_i) in getTitles" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">-->
<!--                    <div class="flex items-center">-->
<!--                      <div v-if="form.inspectChecked.includes(_title)" style="background: #696d71" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">-->
<!--                        <vs-icon icon="check" size="x-small"></vs-icon>-->
<!--                      </div>-->
<!--                      <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>-->
<!--                      <span class="flex-1">{{ _title }}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </td>-->
<!--            </tr>-->
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <div class="content-title">{{ $t('2. 근로자 및 산업재해 현황') }}</div>
        <table>
          <tbody>
          <tr>
            <th>{{ $t('구분') }}</th>
            <th>{{ $t('조리') }}</th>
            <th>{{ $t('시설관리') }}</th>
            <th>{{ $t('청소') }}</th>
            <th>{{ $t('통학차량보조') }}</th>
            <th>{{ $t('구분') }}</th>
            <th>{{ $t('사망') }}</th>
            <th>{{ $t('부상') }}</th>
            <th>{{ $t('질병') }}</th>
          </tr>
          <tr>
            <th>{{ $t('현업근로자') }}</th>
            <td>{{ form.inputB_1 }}</td>
            <td>{{ form.inputB_2 }}</td>
            <td>{{ form.inputB_3 }}</td>
            <td>{{ form.inputB_4 }}</td>
            <th>{{ $t('전년도') }}</th>
            <td>{{ form.inputD_1 }}</td>
            <td>{{ form.inputD_2 }}</td>
            <td>{{ form.inputD_3 }}</td>
          </tr>
          <tr>
            <th>{{ $t('도급종사자') }}</th>
            <td>{{ form.inputC_1 }}</td>
            <td>{{ form.inputC_2 }}</td>
            <td>{{ form.inputC_3 }}</td>
            <td>{{ form.inputC_4 }}</td>
            <th>{{ $t('당해년도') }}</th>
            <td>{{ form.inputE_1 }}</td>
            <td>{{ form.inputE_2 }}</td>
            <td>{{ form.inputE_3 }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <div class="content-title">{{ $t('3. 최근 3년이내 산업재해 발생 내용') }}</div>
        <table>
          <tbody>
          <tr>
            <th>{{ $t('발생일') }}</th>
            <th>{{ $t('직종') }}</th>
            <th>{{ $t('재해유형') }}</th>
            <th>{{ $t('상해종류') }}</th>
            <th colspan="4">{{ $t('발생개요') }}</th>
          </tr>
          <tr>
            <td>{{ form.inputF_1 }}</td>
            <td>{{ form.inputF_2 }}</td>
            <td>{{ form.inputF_3 }}</td>
            <td>{{ form.inputF_4 }}</td>
            <td colspan="4">{{ form.inputF_5 }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <div class="content-title">{{ $t('4. 점검결과 총평') }}</div>
        <table>
          <tbody>
          <tr>
            <th>{{ $t('주요 지도사항') }}</th>
          </tr>
          <tr>
            <td>
              <p style="min-height: 420px; text-align: start; padding: 14px;">{{ form.inputG_1 }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <div class="content-title print-break-page">{{ $t('5. 점검표') }}</div>
        <table-inspect-merge
          :is-print="true"
          :is-readonly="board.readonly"
          :table-header-title="'점검사항'"
          :table-header-check="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
          :tableHeaderNote="[{ text: '비고' },]"
          contentBefore="•"
          v-model="form.inspectList"
          :only-pc="true"
          class="mt-5"
        >
          <template #customType="{ trData, id, input }">
            <div v-if="trData && trData.customType === '1'" class="p-2">
              <div class="flex justify-between items-center">
                <span>{{ $t('실시일') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input1 }}</p>
              </div>
              <div class="flex justify-between items-center mt-1">
                <span>{{ $t('실시일') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input2 }}</p>
              </div>
            </div>
            <div v-else-if="trData && trData.customType === '2'" class="p-2">
              <div class="flex justify-between items-center">
                <span>{{ $t('교육대상') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input1 }}</p>
              </div>
              <div class="flex justify-between items-center mt-1">
                <span>{{ $t('실시인원') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input2 }}</p>
              </div>
            </div>
            <div v-else-if="trData && trData.customType === '3'" class="p-2">
              <div class="flex justify-between items-center mt-1">
                <span>{{ $t('실시일') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input1 }}</p>
              </div>
              <div class="flex justify-between items-center mt-1">
                <span>{{ $t('개선사항') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input2 }}</p>
              </div>
              <div class="flex justify-between items-center mt-1">
                <span>{{ $t('조치사항') }}</span>
                <p class="flex-1 ml-1">: {{ trData.input3 }}</p>
              </div>
            </div>
          </template>
        </table-inspect-merge>
      </div>
      <div class="content-table mt-28">
        <div class="content-title print-break-page">{{ $t('6. 관리적요인 개선조치 요구사항') }}</div>
        <table style="margin-bottom: 12px;">
          <colgroup>
            <col />
            <col width="146" />
          </colgroup>
          <tbody>
          <tr>
            <th style="font-size: 14px;">{{ $t('개선조치 요구사항') }}</th>
            <th style="font-size: 14px;">{{ $t('자체개선/조치보고') }}</th>
          </tr>
          <tr v-for="row in form.requirementList">
            <td style="font-size: 14px;">{{row.cell1}}</td>
            <td style="font-size: 14px;">{{row.cell2}}</td>
          </tr>
          </tbody>
        </table>
        <p style="color: #0079E9;text-align: center;">{{ $t('※ 조치보고 사항은 파일첨부하여 회신하여 주십시오.') }}</p>
      </div>
      <div class="content-table">
        <div class="content-title"><i class="dot"></i>{{ $t('사진대지') }}</div>
        <photo-upload-grid-module
          :printRowCount="1"
          v-model="form.photoList"
          :is-print="true"
          :readonly="board.readonly"
          placeholder="신축현장 점검"
        />
      </div>
    </div>

  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
export default {
  name: "Print669",
  components: {TableCustom, DateSelector, TableInspectMerge},
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    getTitles() {
      if (!this.form.inspectList) {
        return [];
      }
      return this.form.inspectList.map((item) => item.title);
    },
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 14px;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 10px;
    }
  }
  .header-table {
    table {
      width: 100%;
      border-collapse: collapse;
      tr:nth-child(1) {
        text-align: center;
        td {
          padding: 10px;
        }
        td:nth-child(n + 2) {
          font-size: 18px;
          font-weight: 500;
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
      tr:nth-child(2) {
        height: 100px;
        td:nth-child(1) {
          padding-bottom: 15px;
        }
        td:nth-child(n + 2) {
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
    }
    .header-in-table {
      font-size: 32px;
      font-weight: 700;
      line-height: 24px;
    }
    .signCell {
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .content-table {
    .sub-header,
    .item-label {
      padding: 14px;
      text-align: left;
      font-size: 18px;
    }
    .sub-header {
      font-weight: 700;
    }
    .row-title {
      font-weight: 500;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th,
      td {
        border: 1px solid #cdcdcd;
        text-align: center;
        min-height: 55px;
        height: 55px;
        font-size: 18px;
      }
      th {
        background-color: #f9f9f9;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
        img {
          display: inline-block;
        }
      }
      .check-container {
        padding: 10px 14px 0 14px;
        text-align: left;

        div {
          margin-bottom: 8px;
        }
        img {
          display: inline-block;
          margin-right: 8px;
        }
      }
      .text-left {
        text-align: left;
        padding: 10px 14px;
      }
    }

    /*서명 테이블*/
    .sign-table {
      th,
      td {
        font-size: 14px;
      }

      tr th:nth-child(1),
      tr td:nth-child(1),
      tr th:nth-child(8),
      tr td:nth-child(8) {
        width: 64px;
      }

      .signCell {
        white-space: nowrap;
        min-width: 90px;
        padding: 2px;
        height: 50px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .signSpace {
        width: 10px;
        border-top: none;
        border-bottom: none;
      }
    }
  }

  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }

  .print-break-page {
    page-break-before: always;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
    break-inside: avoid;
  }
}
.photoWrap:nth-child(2n) {
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.table-inspect-merge-print {
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    color: #3c3c3c;

    display: flex;
    align-items: center;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 14px;
    }
  }

  .print-textarea,
  .print-input {
    border: none;
    border-radius: 0;
  }

  table {
    th,
    td {
      border: 1px solid #757575 !important;
      min-height: 55px !important;
      height: 55px !important;
      font-size: 18px !important;
      text-align: center !important;
    }
    th {
      background-color: #ececec !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }

    .title-tr > td {
      background-color: #ececec !important;
      text-align: left !important;
    }

    .content[colspan='4'],
    .content[colspan='7']{
      padding: 0 !important;

      & > div {
        display: grid !important;
        grid-template-columns: auto 1fr;
        gap: 0 !important;
      }
      p {
        flex: none ;
        padding: 0.7rem !important;
        width: 140px !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        margin: 0 !important;
        border-left: 1px solid #757575 !important;
        white-space: pre-wrap;

        display: grid;
        align-items: center;
      }
    }
  }
}
</style>
